import PropTypes from 'prop-types';
import {withFormik as form} from 'formik';

export const formProps = {
  values: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
};

export {form};
